import React from 'react'

const OverviewTitle = ({ children }) => (
  <div className="pb-3 text-base font-semibold text-gray-1100">{children}</div>
)

export default OverviewTitle
